/**
 * Design tokens — единый источник для MiniApp и web-booking.
 * Значения совпадают с web-master ui-tokens (UI-KIT).
 */
export const spacing = {
    2: '2px',
    4: '4px',
    6: '6px',
    8: '8px',
    10: '10px',
    12: '12px',
    14: '14px',
    16: '16px',
    20: '20px',
    24: '24px',
    32: '32px',
    40: '40px',
    48: '48px',
    80: '80px',
};
/** Семантические алиасы (UI-KIT). Ссылки на spacing. */
export const spacingAliases = {
    headerToContent: spacing[8],
    sectionGap: spacing[12],
    blockGap: spacing[8],
    fieldGap: spacing[8],
    labelToField: spacing[8],
};
/** Для CSS var(--spacing-xs) и т.д. */
export const spacingCss = {
    xs: spacing[4],
    sm: spacing[8],
    md: spacing[12],
    lg: spacing[16],
    xl: spacing[24],
    xxl: spacing[32],
};
export const radius = {
    4: '4px',
    6: '6px',
    8: '8px',
    10: '10px',
    12: '12px',
    14: '14px',
    16: '16px',
};
export const radiusCss = {
    sm: radius[4],
    md: radius[8],
    lg: radius[12],
    xl: radius[16],
};
/** Elevation = shadow. UI-KIT elevation sm/md/lg. */
export const elevation = {
    none: 'none',
    sm: '0 1px 1px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
    md: '0 2px 2px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)',
    lg: '0 4px 4px rgba(0,0,0,0.08), 0 4px 8px rgba(0,0,0,0.06)',
    xl: '0 8px 8px rgba(0,0,0,0.08), 0 8px 16px rgba(0,0,0,0.06)',
    '2xl': '0 12px 12px rgba(0,0,0,0.10), 0 12px 24px rgba(0,0,0,0.08)',
};
export const elevationCss = {
    sm: elevation.sm,
    md: elevation.md,
    lg: elevation.lg,
    xl: elevation.xl,
};
/** Типографика (UI-KIT). Роли: title=md, body=sm, meta=xs, micro. */
export const typographyCss = {
    micro: '11px',
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '48px',
};
export const fontWeightCss = {
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
};
/**
 * Межстрочный интервал (unitless, UI-KIT).
 * titleCompact — заголовок в одной строке с иконками/кнопками (шапки экранов).
 */
export const lineHeightCss = {
    titleCompact: '1.2',
    title: '1.3',
    body: '1.5',
};
/** Overlay для модалок. */
export const overlayCss = {
    bg: 'rgba(0, 0, 0, 0.5)',
};
//# sourceMappingURL=design-tokens.js.map